import React from 'react'

import HeaderSection from '../componets/HeaderSection'
import MainSection from '../componets/MainSection'
import BelowMain from '../componets/BelowMain'
import Footer from '../componets/Footer'

const Home = () => {
  return (
    <div>
    
      <div className=''><HeaderSection/></div>
      <div className=''><MainSection/></div> 
      <div className=''><BelowMain/></div>
      <div className='mt-3'><Footer/></div>
    </div>
  )
}

export default Home
